//
//
//
//
//
//
//
//
//
//
//
//

import vuexMixin from '@/lib/vuexMixin'

export default {
  name: "layoutAdmin",
  mixins: [vuexMixin],
  props: {
    menu: String, 
    titlePage:{
      type:String,
      default: ''
    },
    breadcrumbsProp:{
        type:Array,
        default(){
          return []
        }
    },
    objApiConsumed: {
      type: Object,
      default(){
        return null
      }
    }
  },
  data() {
    return {
      loading: true,
      breadcrumbsAtualizado:[],
    }
  },
  created() {
    this.$nextTick(function() {
      this.loading = false
    })
  },
  watch: {
    breadcrumbsProp:{
      handler(navArray) {
        this.breadcrumbsAtualizado = [...navArray]
      },
      immediate: true

    }
  },
}
